import { createRef } from 'react';
import { RefObject } from 'react';
import { WritableDraft } from 'immer';
import { Camera } from 'three';
import { OrbitControls } from 'three-stdlib';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export const booleans = {
  isPerformance: false,
  isDebug: false,
  isEditor: false,
  isStats: false,
};

type Booleans = keyof typeof booleans;
type BaseState = Record<Booleans, boolean>;

export interface IState extends BaseState {
  intro: {
    skip: boolean;
    horse: {
      time: number;
    };
    camera: {
      time: number;
      from: {
        x: number;
        y: number;
        z: number;
      };
      to: {
        x: number;
        y: number;
        z: number;
      };
    };
  };
  camera: {
    ref: RefObject<Camera | null>;
    position: {
      x: number;
      y: number;
      z: number;
    };
    orbitControlsRef: RefObject<OrbitControls | null>;
  };
  light: {
    position: {
      x: number;
      y: number;
      z: number;
    };
    angle: number;
    penumbra: number;
    distance: number;
    intensity: number;
  };
  scale: number;
  set: (
    nextStateOrUpdater:
      | IState
      | Partial<IState>
      | ((state: WritableDraft<IState>) => void),
    shouldReplace?: false
  ) => void;
}

export const INITIAL_STORE_VALUE = {
  ...booleans,
  scale: 10,
  intro: {
    skip: false,
    horse: {
      time: 3,
    },
    camera: {
      time: 3,
      from: {
        x: 269,
        y: 195,
        z: 1000,
      },
      to: {
        x: 0.4,
        y: 112.8,
        z: 200.2,
      },
    },
  },
  camera: {
    // eslint-disable-next-line react-x/no-create-ref
    ref: createRef<Camera>(),
    position: {
      x: -125,
      y: 52,
      z: 112,
    },
    // eslint-disable-next-line react-x/no-create-ref
    orbitControlsRef: createRef<OrbitControls>(),
  },
  light: {
    position: {
      x: -62,
      y: 443,
      z: 89,
    },
    angle: 90,
    penumbra: 0.5,
    distance: 0,
    intensity: 1556600,
  },
};

export const useSystemBaseStore = create<IState>()(
  immer((set) => ({
    ...INITIAL_STORE_VALUE,
    set,
  }))
);
